var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.001 70C15.6047 70 -0.145278 54.5412 0.00101089 35C0.1473 15.4588 14.876 0 35.001 0C55.1274 0 70.001 15.75 70.001 35C70.001 54.25 54.3973 70 35.001 70ZM45.3547 64.6037L35.4385 37.9162L26.1047 65.1875C32.9598 66.7926 37.626 67.2287 45.3547 64.6037ZM21.1473 63.1463L6.2723 22.4588C4.22972 26.8338 3.79359 30.4801 3.50101 35C3.6473 46.9574 10.3547 57.8949 21.1473 63.1463ZM66.3561 35C66.501 27.2713 63.0024 21.1463 62.7098 20.2713C63.0024 26.2514 62.126 29.3125 61.1061 32.6676L50.8973 61.9801C63.7311 54.25 66.2084 42.7287 66.501 35H66.3561ZM33.9811 33.6875L29.0223 20.125L25.376 19.8338C23.9186 18.8125 24.7922 17.2088 25.8135 17.2088C32.376 17.6463 36.0209 17.6463 42.5848 17.2088C44.1899 17.2088 44.626 19.5426 42.7297 19.8338L39.2297 20.125L50.6034 53.6662L55.9983 35.2912C56.2909 27.2713 54.102 26.3963 51.1858 20.5625C48.852 16.0412 51.3321 11.6662 55.8534 11.5213C52.2057 8.02129 44.7696 3.64629 34.9983 3.5C25.227 3.35371 14.8733 8.3125 8.74828 17.6463L19.5409 17.3551C20.8534 17.9389 20.2696 19.8338 19.5409 19.9801L15.7496 20.2713L27.1246 54.3963L33.9811 33.6875Z",
    fill: "#21759B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode9);
export default __webpack_public_path__ + "static/media/code9.9bea63d93c3ddb9b7e3a8e124a0a1c62.svg";
export { ForwardRef as ReactComponent };